import { footerQuickLinks, footerPrograms } from "@/content/footer";

export interface SitemapLink {
  href: string;
  label: string;
}

export interface SitemapSection {
  id: string;
  title: string;
  links: SitemapLink[];
}

export const sitemapSections: SitemapSection[] = [
  {
    id: "main",
    title: "Main Pages",
    links: footerQuickLinks,
  },
  {
    id: "programs",
    title: "Programs",
    links: footerPrograms.map(({ href, label }) => ({ href, label })),
  },
  {
    id: "legal",
    title: "Legal",
    links: [
      { href: "/privacy-policy", label: "Privacy Policy" },
      { href: "/terms-of-service", label: "Terms of Service" },
    ],
  },
  {
    id: "email",
    title: "Email preferences",
    links: [
      { href: "/newsletter/unsubscribe", label: "Newsletter unsubscribe" },
    ],
  },
];

export const sitemapPage = {
  eyebrow: "Site Map",
  title: "Sitemap",
  subtitle: "Browse all pages on the AJA Abhaya Hastham Foundation website.",
  xmlNote: "Search engines can also use our XML sitemap.",
  xmlHref: "/sitemap.xml",
} as const;
